module.exports = __webpack_public_path__ + "static/media/heart8.f78b9de3.png";